// http-helpers.js — helpers HTTP COMPARTIDOS por los handlers del drain (modules/occurrences.js y
// modules/tasks.js). Antes estaban duplicados byte-idéntico en ambos módulos (deuda de duplicación).

/** Header Idempotency-Key = row.mutation_uuid (hardening; el backend hoy lo ignora). */
export const idemHeader = (row) => ({ headers: { 'Idempotency-Key': row.mutation_uuid } })

/** True si la respuesta del transport es 2xx (camino feliz). */
export function is2xx (res) {
  return res && res.status >= 200 && res.status < 300
}

/**
 * Lanza un Error normalizado (con status) a partir de un no-2xx-pero-no-rechazado, para que el
 * clasificador del drain decida (no se traga el error). Si el transport YA rechazó, el handler deja
 * propagar el rechazo tal cual (classify lee dual-shape).
 */
export function throwFromResponse (res) {
  const err = new Error(`HTTP ${res && res.status}`)
  err.status = res && res.status
  err.response = res
  throw err
}
